// extracted by mini-css-extract-plugin
export default {"root":"Bubbles_root__XwNCa","bubble":"Bubbles_bubble__-zB9d","active":"Bubbles_active__2tCcE"};